import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: ContentData = {
    totalCount: 5,
    filteredCount: 5,
    labelCount: "Treffer",
    schema: {
        check: {
            type: ColumnTypes.Checkbox,
            sortable: false,
            "primary-mobile": false,
        },
        machine: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": true,
        },
        machineNum: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        location: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
    },
    items: [
        {
            check: "WDEDEMO009",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO009",
            location: "Munich",
        },
        {
            check: "WDEDEMO010",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO010",
            location: "London",
        },
        {
            check: "WDEDEMO011",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO011",
            location: "Liverpool",
        },
        {
            check: "WDEDEMO012",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO012",
            location: "Paris",
        },
        {
            check: "WDEDEMO013",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO013",
            location: "Cologne",
        },
    ],
};


const response2: ContentData = {
    totalCount: 5,
    filteredCount: 5,
    labelCount: "Treffer",
    schema: {
        check: {
            type: ColumnTypes.Checkbox,
            sortable: false,
            "primary-mobile": false,
        },
        machine: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": true,
        },
        machineNum: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        location: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
    },
    items: [
        {
            check: "WDEDEMO014",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO014",
            location: "Munich",
        },
        {
            check: "WDEDEMO015",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO015",
            location: "London",
        },
        {
            check: "WDEDEMO016",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO016",
            location: "Liverpool",
        },
        {
            check: "WDEDEMO017",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO017",
            location: "Paris",
        },
        {
            check: "WDEDEMO018",
            machine: "TruMatic 7000 Großformat",
            machineNum: "WDEDEMO018",
            location: "Cologne",
        },
    ],
};

const response1 = {
    ...response,
    nextPage: `generated-mock-data/ecat-modal-step1-2.json`,
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response1, "ecat-modal-step1");
writeToFile(response2, "ecat-modal-step1-2");
